module.exports = __webpack_public_path__ + "static/img/background.5d4b719e.svg";